import { WorkerAction, WorkerActionError, WorkerFnParams } from '../wasm-git.worker.model';
import type { GitAction } from './actions.enum';

export interface GitRevertAction extends WorkerAction {
  type: GitAction.Revert;
  params: { commitSha: string; isMergeCommit?: boolean };
}

export class GitRevertActionError extends WorkerActionError {}

/**
 * The only available option is 'git revert [commit ID]'
 * which revert the whole commit
 * to revert a single file please use git checkout [commit ID]~1 -- path/to/file
 */
export async function GitRevertActionFn({ lg, params, util }: WorkerFnParams<GitRevertAction>): Promise<void> {
  try {
    const { commitSha, isMergeCommit } = params;
    lg.callAndCaptureOutput(['revert', ...(isMergeCommit ? ['-m'] : []), commitSha]);
  } catch (err) {
    throw new GitRevertActionError(err);
  } finally {
    await util.syncfs(false);
  }
}
